import { Application } from "@hotwired/stimulus";

// Boot Stimulus
const application = Application.start();

// Configure Stimulus development experience
application.debug = false;
window.Stimulus = application;

// Register Stimulus controllers
function registerControllers(globObject) {
  Object.entries(globObject).forEach(([path, controller]) => {
    let normalizedPath = "";
    if (path.includes("/controllers/")) {
      normalizedPath = path
        .replace(/^.+\/controllers\//, "")
        .replace(/_controller\.js$/, "")
        .replace(/\.js$/, "");
    } else if (path.includes("public")) {
      // When a controller is in the public space, it includes extra directories in the path,
      // e.g. "../../../{pack name}/app/public/clinical_trial/components"
      // leading to a controller name like: '..--{pack name}--app--public--components'
      normalizedPath = path.replace(/^.+\/public/, "public/");
    } else {
      // Paths are relative, so those from the core pack start "../components" while those from
      // other packs start with "../../../{pack name}/app/components"
      normalizedPath = path.replace(/^.+(\/components)/, "../components");
    }

    const pathPaths = path.includes("/controllers/")
      ? normalizedPath.split("/")
      : normalizedPath.replace(".js", "").split("/").slice(2);

    // Because we nest our components in a folder with the same name as the component, we can end up
    // with duplication in the controller name
    if (!path.includes("/controllers/")) {
      pathPaths.splice(-2, 1);
    }

    const controllerName = pathPaths.join("--").replace(/_/g, "-");

    if (import.meta.env.DEV || import.meta.env.MODE === "test") {
      console.log("Registering Stimulus controller:", controllerName);
    }

    application.register(controllerName, controller.default);
  });
}

let controllers = import.meta.glob(
  "@clinicalTrialPack/app/components/**/*_component.js", { eager: true }
);
registerControllers(controllers);

controllers = import.meta.glob(
  "@clinicalTrialPack/app/public/clinical_trial/components/**/*.js", { eager: true }
);
registerControllers(controllers);

controllers = import.meta.glob(
  "@corePack/app/components/**/*_component.js", { eager: true }
);
registerControllers(controllers);

controllers = import.meta.glob(
  "@corePack/app/public/components/**/*_component.js", { eager: true }
);
registerControllers(controllers);

controllers = import.meta.glob(
  "@corePack/app/frontend/javascript/controllers/**/*_controller.js", { eager: true }
);
registerControllers(controllers);

export { application };
